var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircle = function SvgArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 .826 3.37 2.888L7 6.603V4.816C5.19 5.194 4 6.573 4 8c0 .463.009 1.05.247 1.607a1 1 0 0 1-1.84.786C2 9.438 2 8.493 2 8.027V8c0-2.731 2.263-4.8 5-5.211V.826zm5.28 4.254a1 1 0 0 1 1.313.527c.408.955.407 1.9.407 2.366V8c0 2.732-2.263 4.8-5 5.211v1.963l-3.37-2.888L9 9.397v1.787c1.81-.378 3-1.757 3-3.184 0-.463-.008-1.05-.246-1.607a1 1 0 0 1 .526-1.313z"
  })));
};
export default SvgArrowCircle;